module.exports = __webpack_public_path__ + "img/copy.57b2ed96.svg";